import React from "react";
import DeviceForm from "../components/DeviceForm";
const AddDevice = () => {
  return <DeviceForm/>;
};
export default AddDevice;
